import type { ReactElement, ReactNode, RefObject } from 'react';
import { ModalLocation } from '@/constants/componentPresets';
import { getContentStyle, getMainContentStyle, } from './Cmodal.styles';
import { CmodalTitle } from './CmodalTitle';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CmodalContentProps {
    dataElScope: DataElScope;
    contentRef: RefObject<HTMLDivElement | null>;
    mainContentRef: RefObject<HTMLDivElement | null>;
    location: ModalLocation;
    content?: ReactNode;
    menuTitle?: string;
    titleExtra?: string;
    titleRightComponent?: ReactNode;
}
export function CmodalContent({ dataElScope, contentRef, mainContentRef, location, content, menuTitle, titleExtra, titleRightComponent, }: CmodalContentProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, 'Content/Root')} ref={contentRef} style={getContentStyle({ location })}>
        {menuTitle && (<CmodalTitle dataElScope={dataElScope} menuTitle={menuTitle} titleExtra={titleExtra} titleRightComponent={titleRightComponent}/>)}
        <div data-el={dataEl(dataElScope, 'Content/MainContent')} ref={mainContentRef} style={getMainContentStyle({ location })}>
          {content}
        </div>
      </div>
    );
}
